import React from "react";
import { XIcon, CheckIcon, ArrowDownIcon, ArrowRightIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { beforeItems, afterItems } from "../../data/content";
export function BeforeAfter() {
  return <section className="px-4 py-16 md:py-24" aria-labelledby="ba-title" data-id="element-39" data-mp="22l13hdb9fdge">
      <div className="mx-auto max-w-5xl" data-id="element-40" data-mp="22ioeig7342tu">
        <SectionHeading title={<span id="ba-title" data-id="element-42" data-mp="2za8omk7yvkjs">
              Before vs. <em className="text-go" data-id="element-43" data-mp="2ubfcow8bw1lq">with</em> the Sensory Decision Map™
            </span>} data-id="element-41" data-mp="2zba2sxka4n5q" />

        <div className="mt-10 grid items-stretch gap-4 md:grid-cols-[1fr_auto_1fr] md:gap-5" data-id="element-44" data-mp="2q9kalpikpk6w">
          <div className="rounded-3xl border-2 border-stop/20 bg-stop-light p-6 md:p-8" data-id="element-45" data-mp="2lc20hvstkyxb">
            <p className="inline-flex items-center gap-2 rounded-full bg-stop px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-46" data-mp="1evpyfjmvmwwg">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="19usjrh12skzp" /> Before
            </p>
            <ul className="mt-5 space-y-4" data-id="element-48" data-mp="176nnrw6wp970">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-49" data-mp="1c35siw28l7jc">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-stop/15 text-stop" data-id="element-50" data-mp="y4o8p9fgcf6p">
                    <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-51" data-mp="132zijk5qypox" />
                  </span>
                  <span className="text-[16px] leading-snug text-ink" data-id="element-52" data-mp="odtjpxatn1hk">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center" aria-hidden="true" data-id="element-53" data-mp="t7fluvjczmz4">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-900 text-white" data-id="element-54" data-mp="fc3iy0v1uq74">
              <ArrowDownIcon className="h-6 w-6 md:hidden" data-id="element-55" data-mp="jdfbof97zrjj" />
              <ArrowRightIcon className="hidden h-6 w-6 md:block" data-id="element-56" data-mp="5hbjssltjva8" />
            </span>
          </div>

          <div className="rounded-3xl border-2 border-go/25 bg-go-light p-6 md:p-8" data-id="element-57" data-mp="adsc7z01wvt4">
            <p className="inline-flex items-center gap-2 rounded-full bg-go px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-58" data-mp="2c5aufh33eyda">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="27bpu3ie11sax" /> After
            </p>
            <ul className="mt-5 space-y-4" data-id="element-60" data-mp="239uwooz7vz2f">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-61" data-mp="1yep9lmu2wecr">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-go text-white" data-id="element-62" data-mp="2v3etfip9nh1d">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-63" data-mp="2r2uvicwvc9e6" />
                  </span>
                  <span className="text-[16px] font-medium leading-snug text-ink" data-id="element-64" data-mp="2m0m079wiwv8w">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12" data-id="element-65" data-mp="1aobdnl8dhvcw">
          <CtaButton label="I want a clearer clinical reasoning system" data-id="element-66" data-mp="1al7408c527eu" />
        </div>
      </div>
    </section>;
}